import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import RequestsByWeekListByCompany from './components/week/RequestsByWeekListByCompany';
import RequestsByMonthByCompanyList from './components/month/RequestsByMonthListByCompany';

function RequestsByCompany() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Requests by company"
      MonthList={RequestsByMonthByCompanyList}
      WeekList={RequestsByWeekListByCompany}
      storageKey="report-group-by"
    />
  );
}

export default RequestsByCompany;
